/**
 * Office Add-in Dialog がユーザーによって閉じられた (X ボタン押下等) ことを示すエラー。
 * Office.js が DialogEventReceived の `arg.error === 12006` で通知する事象に対応する。
 */
export class DialogCancelledError extends Error {
    constructor() {
        super("Dialog cancelled by user");
        this.name = "DialogCancelledError";
    }
}
